import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import PlayBtn from "../../../SVGs/PlayBtn";
import Overlay from "./Overlay";
import SeekerBar from "./SeekerBar";
import VideoFeatures from "./VideoFeatures";

function VideoPlayer({ video, data }) {
  const [currentTime, setCurrentTime] = useState(0);
  const [isSeeking, setIsSeeking] = useState(false);
  const [isVideoPaused, setIsVideoPaused] = useState(true);
  const [volume, setVolume] = useState(1);
  const [activeStep, setActiveStep] = useState(0);
  const [totalLength, setTotalLength] = useState(0);
  const [progress, setProgress] = useState(0);

  const videoRef = useRef();
  const playerRef = useRef(null);
  const waveSurfer =
    playerRef?.current && playerRef?.current?.wavesurfer()?.surfer;

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // error handling
    player.on("error", (element, error) => {
      console.error(error);
    });
  };
  useEffect(() => {
    if (waveSurfer) {
      videoRef?.current.addEventListener("loadedmetadata", () => {
        let current = videoRef?.current;
        const duration = current?.duration;

        setCurrentTime(current.currentTime);
        setTotalLength(duration);
        waveSurfer?.seekTo(current?.currentTime / duration);
      });
      waveSurfer?.on("audioprocess", () => {
        setCurrentTime(waveSurfer?.getCurrentTime());
      });
      waveSurfer.setVolume(0);
    }
  }, []);

  useEffect(() => {
    if (!isVideoPaused) {
      playerRef?.current && playerRef?.current?.play();
    } else {
      playerRef?.current && playerRef?.current?.pause();
    }
  }, [isVideoPaused]);

  const handleVideoPlay = () => {
    setIsVideoPaused(false);
    videoRef.current?.play();
    playerRef?.current && playerRef?.current?.play();
  };

  const handleVideoPause = () => {
    setIsVideoPaused(true);
    videoRef.current?.pause();
    playerRef?.current && playerRef?.current?.pause();
  };

  const handleWaveformSeek = (event) => {
    const waveformWidth = event.target.clientWidth;
    const clickPosition = event.nativeEvent.offsetX;
    const percentage = clickPosition / waveformWidth;
    const seekTime = videoRef.current.duration * percentage;

    setCurrentTime(seekTime);
    videoRef.current.currentTime = seekTime;
    waveSurfer?.seekTo(percentage);
  };

  const handleVideoSeek = (event) => {
    const seekTime = event.target?.currentTime;
    setCurrentTime(seekTime);
    waveSurfer?.seekTo(seekTime / videoRef.current.duration);

    const videoProgress = (seekTime / videoRef.current.duration) * 100;
    setProgress(videoProgress);

    const activeStepIndex = Math.floor(
      (seekTime / videoRef.current.duration) * 11
    );
    setActiveStep(activeStepIndex);
  };

  const handleWaveformDragStart = () => {
    setIsSeeking(true);
  };

  const handleWaveformDrag = (event) => {
    if (!isSeeking) return;
    handleWaveformSeek(event);
  };

  const handleWaveformDragEnd = () => {
    setIsSeeking(false);
    videoRef.current.currentTime = currentTime;
  };

  const handleVolumeChange = (event) => {
    const volume = event.target.value;
    setVolume(volume);
    // videoRef.current.volume = volume;
    waveSurfer.setVolume(volume);
  };

  // const [livePoll, setLivePoll] = useState(false);

  return (
    <Box sx={{ width: 1 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: 1,
            height: "654px",
            display: "grid",
            placeItems: "center",
            backgroundColor: "background.black",
          }}
        >
          <video
            src={data}
            poster={video?.poster}
            style={{
              height: "640px",
              width: "100%",
              objectPosition: "center",
            }}
            muted
            onPlay={handleVideoPlay}
            onPause={handleVideoPause}
            onTimeUpdate={handleVideoSeek}
            preload="metadata"
            onLoadedMetadata={() => {
              const duration = videoRef.current.duration;
              setCurrentTime(videoRef.current?.currentTime);
              waveSurfer?.seekTo(videoRef.current?.currentTime / duration);
            }}
            ref={videoRef}
          />
        </Box>
        <VideoFeatures
          features={video?.features}
          currentTime={currentTime}
          videoRef={videoRef}
          play={handleVideoPlay}
          pause={handleVideoPause}
        />
        {isVideoPaused && (
          <>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: "100%",
                height: "100%",
                zIndex: 10,
                fill: "#f9f9f9",
                stroke: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: "30px",
                    sm: "60px",
                    md: "80px",
                    xl: "100px",
                  },
                  cursor: "pointer",
                  transition: "0.5s all",
                }}
                onClick={handleVideoPlay}
              >
                <PlayBtn />
              </Box>
            </Box>

            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
                pointerEvents: "none",
              }}
            >
              <img
                src="/images/videobgd.svg"
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
          </>
        )}

        {!isVideoPaused && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 10,
            }}
            onClick={handleVideoPause}
          ></Box>
        )}

        <Overlay volume={volume} handleVolumeChange={handleVolumeChange} />
      </Box>
      {/* <CustomizedSteppers
        activeStep={activeStep}
        progress={progress}
        totalLength={totalLength}
      /> */}
      {/* <FeaturesBar /> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <SeekerBar
          handleWaveformSeek={handleWaveformSeek}
          handleWaveformDragStart={handleWaveformDragStart}
          handleWaveformDrag={handleWaveformDrag}
          handleWaveformDragEnd={handleWaveformDragEnd}
          currentTime={currentTime}
          videoRef={videoRef}
          isVideoPaused={isVideoPaused}
          handlePlayerReady={handlePlayerReady}
          video={video?.media}
        />
      </Box>
    </Box>
  );
}

export default VideoPlayer;
